/**
 * Creates a submit handler function that manages loading state and navigation
 *
 * @param options - Configuration options for the submit handler
 * @param options.setLoading - Function to set loading state
 * @param options.handleSubmit - Function that performs the submission and returns success status
 * @param options.onSuccess - Function to call when submission is successful
 * @returns A function that handles the submission process
 */

type SubmitHandlerOptions = {
  handleSubmit: () => Promise<boolean>;
  onSuccess: () => void;
  onFailure?: (error: Error) => void;
  onFinally?: () => void;
  startLoadingState: () => void;
};

export const createSubmitHandler = ({
  startLoadingState,
  handleSubmit,
  onSuccess,
  onFailure,
  onFinally,
}: SubmitHandlerOptions) => {
  return async (): Promise<void> => {
    startLoadingState();

    try {
      const success = await handleSubmit();

      if (success) onSuccess();
    } catch (error) {
      console.error(error);

      if (onFailure) onFailure(error as Error);
    } finally {
      if (onFinally) onFinally();
    }
  };
};
